import { useEffect } from "react"
import TagManager from "react-gtm-module"

const TagManagerContainer = () => {
  useEffect(() => {
    const tagManagerArgs = {
      gtmId: "GTM-PSHBVTT2",
      dataLayer: {
        app: "turnus-ai",
        data: new Date().toLocaleDateString(),
      },
    }
    TagManager.initialize(tagManagerArgs)

    return () => {
      const scripts = document.querySelectorAll(
        `script[src*="googletagmanager"]`,
      )
      scripts.forEach((s) => s.remove())
    }
  }, [])

  return null
}

export default TagManagerContainer
